import { array, string, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';

export const DifficultyRatingFilter = struct({
	equalsType: EqualsType,
	values: array(string),
});
